import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientWelcomeHeader = ({ clientName = "Margaret Chen", onLogout }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const hour = currentTime?.getHours();
    if (hour < 12) {
      setGreeting('Good Morning');
    } else if (hour < 17) {
      setGreeting('Good Afternoon');
    } else {
      setGreeting('Good Evening');
    }
  }, [currentTime]);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <header className="bg-surface border-b border-border p-8 touch-spacing">
      <div className="flex items-center justify-between">
        {/* Welcome Section */}
        <div className="flex items-center space-x-6">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center">
            <Icon name="User" size={32} color="white" />
          </div>
          <div>
            <h1 className="text-4xl font-bold text-foreground mb-2">
              {greeting}, {clientName}!
            </h1>
            <p className="text-xl text-muted-foreground">
              Ready to continue your fitness journey?
            </p>
          </div>
        </div>

        {/* Time and Controls */}
        <div className="flex items-center space-x-6">
          {/* Current Time */}
          <div className="text-right">
            <p className="text-2xl font-bold text-foreground">
              {currentTime?.toLocaleTimeString([], { 
                hour: '2-digit', 
                minute: '2-digit' 
              })}
            </p>
            <p className="text-lg text-muted-foreground">
              {currentTime?.toLocaleDateString([], { 
                weekday: 'long', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>

          {/* Emergency Button */}
          <Button
            variant="destructive"
            size="lg"
            iconName="Phone"
            iconPosition="left"
            className="breathing-focus haptic-button min-h-touch"
            onClick={() => console.log('Emergency assistance requested')}
          >
            Emergency
          </Button>

          {/* Logout Button */}
          <Button
            variant="outline"
            size="lg"
            iconName="LogOut"
            iconPosition="left"
            className="breathing-focus haptic-button min-h-touch"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      </div>
      {/* Quick Stats */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-primary/5 rounded-xl p-6 text-center border border-primary/10">
          <Icon name="Calendar" size={32} className="text-primary mx-auto mb-2" />
          <p className="text-2xl font-bold text-foreground">12</p>
          <p className="text-sm text-muted-foreground">Sessions This Month</p>
        </div>
        <div className="bg-secondary/5 rounded-xl p-6 text-center border border-secondary/10">
          <Icon name="TrendingUp" size={32} className="text-secondary mx-auto mb-2" />
          <p className="text-2xl font-bold text-foreground">85%</p>
          <p className="text-sm text-muted-foreground">Completion Rate</p>
        </div>
        <div className="bg-success/5 rounded-xl p-6 text-center border border-success/10">
          <Icon name="Target" size={32} className="text-success mx-auto mb-2" />
          <p className="text-2xl font-bold text-foreground">3</p>
          <p className="text-sm text-muted-foreground">Goals Achieved</p>
        </div>
        <div className="bg-warning/5 rounded-xl p-6 text-center border border-warning/10">
          <Icon name="Clock" size={32} className="text-warning mx-auto mb-2" />
          <p className="text-2xl font-bold text-foreground">45</p>
          <p className="text-sm text-muted-foreground">Minutes Average</p>
        </div>
      </div>
    </header>
  );
};

export default ClientWelcomeHeader;